import React,{useState,useEffect} from 'react';
import { BoldHeadText, BoldText1, SmallText } from '../../../helpers/constants/ConstantsText';
import FmsDashboardMainRoot from '../FmsDashboardMainRoot';
import Drawer from '@mui/material/Drawer';
import {Input,Modal,Pagination} from 'antd'
import {useSelector} from 'react-redux'
import PrimaryButton, { SecondaryButton } from '../../../components/buttons/PrimaryButton';
import axios from 'axios';
import {BiEditAlt} from 'react-icons/bi'
import toast,{ Toaster } from 'react-hot-toast';
import { IoClose } from 'react-icons/io5';
import Tooltip from '@mui/material/Tooltip';
import { IoIosClose } from 'react-icons/io';
import { data_not_found } from '../../../helpers/Constants';
import { MdDeleteOutline,MdOutlineRefresh } from 'react-icons/md'
import { AiOutlineFileExcel } from 'react-icons/ai';
import { authHeader } from '../../../helpers/usertoken/UserToken';
import { local_base_url } from '../../../App';
import fileDownload from "js-file-download";

function FmsDesignationOnboardEmployee(){

    const AuthHeader = {headers:{
        'Content-Type': 'application/json',
    }}

    const roles = useSelector(state => state.Auth.roles)

    console.log("roles kp here",roles)


    const [drawer,set_drawer] = useState(false)
    const [data,setdata] = useState({id:'',designation_name:'',display_name:''})
    const [error,seterror] = useState({designation_name_err:'',display_name_err:''})
    const [modalvisible,setmodalvisible] = useState(false)
    const [search,setsearch] = useState('')
    const [designation,setdesignation] = useState([])
    
    const [pagination,setpagination] = useState({})
    const [page,setpage] = useState(1)

    // const { TextArea } = Input;
    const theme_color = useSelector(state=>state.Theme.theme_color)

    // const [pagination,setpagination] = useState()




    function func(){

    }

    function setpagefuun(v){
        setpage(v)
    }




    useEffect(()=>{
        getdata()
    },[page])

    function getdata(){
        axios.get(`fms/fmsdesignationonboardemployee/get?page=${page}`,AuthHeader)
        .then((res)=>{
            setpagination(res.data.pagination)
            setdesignation(res.data.datas)
        }).catch((err)=>{
            // console.log('err data here na',err)
        })
    }

    function searchData(){
        axios.get(`fms/fmsdesignationonboardemployee/search?search_text=${search}`,AuthHeader)
        .then((res)=>{
            setpagination(res.data.pagination)
            setdesignation(res.data.datas)
        }).catch((err)=>{
            // console.log('err data here na',err)
        })
    }
    
    function submitform(){
        if(!data.designation_name){
            seterror({...error,designation_name_err:''})
        }else if(!data.display_name){
            seterror({...error,display_name_err:''})
        }else{
        if(data.id === ''){
            axios.post('fms/fmsdesignationonboardemployee/create',data,AuthHeader)
            .then((res)=>{
                getdata()
                toast.success(res.data.message)
                setdata({display_name:'',designation_name:'',id:''})
                set_drawer(false)

            }).catch((err)=>{
            // console.log('err data here na',err)
            })
        }else{
            axios.put(`fms/fmsdesignationonboardemployee/update/${data.id}`,data,AuthHeader)
            .then((res)=>{
                getdata()
                set_drawer(false)
                toast.success(res.data.message)
                setdata({display_name:'',designation_name:'',id:''})
            }).catch((err)=>{
            // console.log('err data here na',err)
            })
        }
        }
    }


    function deletefunc(){
        axios.delete(`fms/fmsdesignationonboardemployee/delete/${data.id}`,data,AuthHeader)
        .then((res)=>{
            getdata()
            setmodalvisible(false)
            toast.success(res.data.message)
            setdata({display_name:'',designation_name:'',id:''})
        }).catch((err)=>{
        // console.log('err data here na',err)
        })
    }

    async function downloadExcel(){   
        await axios.get(`fms/fmsdesignationonboardemployee/downloadExcel`,authHeader)
        .then((res)=>{
            let path = res.data.path.replace('public/','')
            handleDownload(`${local_base_url}${path}`,path.split('/')[path.split('/')?.length - 1])
            // console.log("res?.data",res?.data)


            // getdata('1')
        })
    //    console.log("download Excel Function")
    }

    const handleDownload = (url, filename) => {
        // console.log('url',url,'filename',filename)

        axios.get(url, {
            responseType: 'blob',
        })
            .then((res) => {
                fileDownload(res.data, filename)
                toast.success("Designation Excel Downloaded") 
            })
    }

    return(
         <FmsDashboardMainRoot>
            <Toaster />

            <Drawer
                anchor='right'
                style={{minWidth:'200px',maxWidth:'200px',zIndex:10}}
                    open={drawer}
                    onClose={()=>{set_drawer(!drawer);setdata({id:'',client_name:'',client_no:'',site_name:'',site_address:'',are_we_serving:true})}}
                > 
                        <div style={{width:'300px',padding:'30px'}}> 
                           
                        <IoClose  style={{position:'absolute',top:'10px',right:'10px',cursor:'pointer'}} onClick={()=>set_drawer(false)} />

                           <div>
                            <BoldHeadText  val="Add/Edit My Designation" fontSize={'15px'} fontWeight='900'/>
                            <p style={{borderBottom:'1px solid #eee'}}></p>
                              

                            <div style={{marginBottom:'10px'}}>
                                <div style={{width:'150px'}}>
                                <SmallText fontWeight={'600'} val={'Designation Name'}  />
                                </div>
                                <Input type="text" style={{borderLeft:`4px solid ${theme_color}`}}  value={data.designation_name} onChange={(e)=>{setdata({...data,designation_name:e.target.value});seterror({...error,designation_name_err:''})}} />
                                </div>

                               <div style={{marginBottom:'10px'}}>
                                <div style={{width:'150px'}}>
                                <SmallText fontWeight={'600'} val={'Display Name'}  />
                                </div>
                                <Input type="text" style={{borderLeft:`4px solid ${theme_color}`}}  value={data.display_name} onChange={(e)=>{setdata({...data,display_name:e.target.value});seterror({...error,display_name_err:''})}} />
                                </div>


                               
                               

                            <p style={{marginTop:'1px'}}></p>
                            
                            <PrimaryButton btn_name={'Continue'} onClick={submitform} />
                            

                          </div>
                        </div>
            </Drawer>
              
              <div style={{display:'flex',alignItems:'center',width:'49%',justifyContent:'space-between'}}>
              <BoldText1 val={`Designation (${pagination?.total !== undefined ? pagination?.total : designation?.length})`} />
              <div style={{display:'flex',alignItems:'center'}}>
              <Input type="text" style={{marginRight:0,width:'40%'}} value={search} onChange={(e)=>setsearch(e.target.value)} onKeyPress={(e)=>e.key === 'Enter' && searchData()} />
               <MdOutlineRefresh onClick={()=>{getdata();setsearch('')}} size={30} style={{marginLeft:'5px',marginRight:'5px',background:'#eee',padding:'4px'}}/>
               {(roles.includes('admin') || roles.includes('fms_hr'))  && 
               <AiOutlineFileExcel onClick={()=>{downloadExcel();}} size={30} style={{marginLeft:'5px',marginRight:'5px',background:'#eee',padding:'4px'}} />}

              <PrimaryButton btn_name={'Add Designation'} onClick={()=>{set_drawer(true);setdata({id:'',client_name:'',client_no:'',site_name:'',site_address:'',are_we_serving:true})}}/>
              </div>
              </div>

              <Modal open={modalvisible} footer={false} closable={false} onCancel={() => setmodalvisible(false)} style={{ maxWidth: '280px' }} centered>
                    <div style={{ maxWidth: '200px', }}>
                    <IoIosClose  onClick={() => setmodalvisible(false)}size={20} style={{position:'absolute',top:'20px',cursor:'pointer',right:'25px',zIndex:100}} />
                        <h6 style={{ padding: '1%', fontWeight: '700', fontSize: '13px' }}>Delete Designation</h6>
                        <h6 style={{ fontSize: '11px', width: '112%', wordBreak: 'break-word', padding: '8px', background: '#def0ff', border: '1px solid #236499', borderRadius: '2px' }}><strong>Note:</strong>do you really want to delete the designation once deleted cannot be retrieved back</h6>
                        <div style={{ display:'flex',width:'100%',marginLeft:'90px',justifyItems:'flex-end'}} >
                            <SecondaryButton btn_name={' Cancel '} width="100%" onClick={()=>{setdata({id:'',client_name:'',client_no:'',site_name:'',site_address:'',are_we_serving:true});setmodalvisible(false)}}/>
                            <PrimaryButton btn_name={' Delete'}  width="100%"  onClick={deletefunc}/>
                        </div>
                    </div>
                </Modal>
             

                <div style={{width:'46%'}}>
                {designation.length > 0 ? 
                               <div  style={{ border: '0px solid lightgray',marginTop:'10px', width:'100%',overflow:'hidden' }}>
                                              <div className='mateial_table_header' style={{border:'1px solid #eaeded',borderRight:'1px solid #eaeded'}}>
                                                  <p className='checked_here' style={{opacity:0}} ></p> 
                                                  <p style={{fontSize:'11px',minWidth: '7%',maxWidth: '5%',borderRight:'1px solid #eaeded', color: 'black',marginLeft:'-9px',marginRight:'10px',opacity:'1' }}>SL No</p>
                                                  <p style={{fontSize:'12px',minWidth: '30.33%',maxWidth: '30%',borderRight:'1px solid #eaeded',marginLeft:'-2px', marginRight: '0.5%' }}>Role Name</p>
                                                  <p style={{fontSize:'12px',minWidth: '30.33%',maxWidth: '30%',borderRight:'1px solid #eaeded',marginLeft:'1px', marginRight: '0.5%' }}>Display Name</p>
                                                  <p style={{fontSize:'12px',minWidth: '22.3%',maxWidth: '10%' }}>Actions</p>
                                              </div>
                                              {designation?.map((d,i)=>(
                                              <div key={d?._id} style={{borderLeft:'1px solid #eaeded',width:'100%',padding:'0px 0px !important',display:'flex',borderRight:'1px solid #eaeded',borderBottom:'1px solid #eaeded',height:'100%'}}>
                                                  <p className='checked_here' style={{opacity:0}} ></p> 
                                                  <p style={{marginBottom:'0px',padding:'4px 0px',fontSize:'11px',paddingLeft:'10px',minWidth: '7%',maxWidth: '5%',borderRight:'1px solid #eaeded', color: 'black',marginRight:'10px',opacity:'1' }}>{page > 1 ? (page - 1) * pagination?.limit + i + 1 : i+1}</p>
                                                  <p style={{marginBottom:'0px',padding:'4px 0px',fontSize:'12px',minWidth: '28.9%',maxWidth: '29%',borderRight:'1px solid #eaeded', marginRight: '0.5%' }}>{d?.designation_name}</p>
                                                  <p style={{marginBottom:'0px',padding:'4px 0px',fontSize:'12px',minWidth: '29.4%',maxWidth: '14.6%',borderRight:'1px solid #eaeded', marginRight: '0.5%' }}>{d?.display_name}</p>
                                                  <p style={{marginBottom:'0px',padding:'4px 0px',fontSize:'12px',minWidth: '8%',maxWidth: '8%' }}>
                                                  <p style={{marginBottom:'0px',padding:'4px 0px',fontSize:'12px',display:'inline',minWidth: '8%',maxWidth: '8%', marginRight: '0.5%' }}>
                                                        
                                                          {/* <AiOutlineEdit style={{marginRight:'10px'}} onClick={() =>{setdata({...data,id:d._id,role_name:d?.role_name,display_name:d?.display_name});set_drawer(true)}}  /> */}
                                                          <BiEditAlt size={14} onClick={() =>{setdata({...data,id:d._id,designation_name:d.designation_name,display_name:d.display_name});set_drawer(true)}} style={{ color: '#000',marginRight:'10px' }}  />
                                                          {/* <AiOutlineDelete onClick={() => {setdata({...data,id:d._id,role_name:d?.role_name,display_name:d?.display_name});setmodalvisible(true)}}  /> */}
                                                          {(roles?.includes('admin') || roles?.includes('fms_hr')) &&
                                                   <MdDeleteOutline size={14} onClick={() => {setdata({...data,id:d._id,client_name:d.client_name,client_no:d.client_no,site_name:d.site_name,site_address:d.site_address,are_we_serving:d.are_we_serving});setmodalvisible(true)}} style={{ color: '#000' }} />}
                                                  </p>
                                                  </p>
                                              </div>))}
                                              <div style={{marginTop:'40px',display:'flex',justifyContent:'center'}}> 
                                {pagination?.total > pagination?.limit &&
                                    <Pagination current={page} size="small" total={pagination?.total} onChange={(v) => setpagefuun(v)}  pageSize={pagination?.limit} />
                                }
                                             </div>
                
                                </div> 
                // <div style={{ border: '0px solid lightgray',marginTop:'0px', overflowY: 'scroll',width:'100%' }}>
                //     <div className='mateial_table_header'>
                //         {/* <p className='checked_here' style={{opacity:0}} ></p>  */}
                //         <p style={{ width: '8%', color: 'black',marginLeft:'15px' }}>Sl No</p>
                //         <p style={{ width: '40%', marginRight: '2%',marginLeft:'15px' }}>Designation Name</p>
                //         <p style={{ width: '40%', marginRight: '2%' }}>Dispaly Name</p>
                       
                //         <p style={{ width: '10%' }}>Actions</p>
                //     </div>


                //     {designation.map((d, i) => (
                //         <div key={i} className={'mateial_table_body'}>
                //             {/* <p  onClick={()=>selected_client !== d._id ? set_selected_client(d._id) : set_selected_client() } className='checked_here' style={{opacity:0}}>
                //             {selected_client === d._id && <p className='checked_here1' style={{background:theme_color}}></p>}
                //             </p> */}
                //             <Tooltip><p style={{ minWidth: '8%',maxWidth:'8%',color: "#000", wordBreak: 'break-word', fontWeight: '700',fontSize:'13px', wordBreak: 'break-word',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',textAlign:'center' }} onClick={() => func(d)}>{page == 1 ?  i+1 : (pagination?.limit * (page-1)) + (i+1)}</p></Tooltip>
                //             <Tooltip  title={d?.designation_name}><p style={{ minWidth: '40%',maxWidth:'40%', color: "#0594f2", wordBreak: 'break-word', fontWeight: '700',fontSize:'13px', wordBreak: 'break-word',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',marginLeft:'25px',marginRight:'2%' }} onClick={() => func(d)}>{d?.designation_name}</p></Tooltip>
                //             <Tooltip  title={d?.display_name}><p style={{ minWidth: '40%',maxWidth:'40%', wordBreak: 'break-word', fontSize:'13px', wordBreak: 'break-word',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',marginLeft:'-10px',marginRight:'2%'}}>{d?.display_name}</p></Tooltip>
                //             {!roles.includes('fms_data_view') && (roles.includes('fms_hr') || roles?.includes('fms_crm_head')) &&
                       
                //             <p style={{ width: '10%', display: 'flex',alignItems:'center',marginLeft:'-25px', }}>
                //             <Tooltip title={'Edit'}>
                //                 <span>
                //                 <BiEditAlt size={14} onClick={() =>{setdata({...data,id:d._id,designation_name:d.designation_name,display_name:d.display_name});set_drawer(true)}} style={{ color: '#000',marginRight:'10px' }}  />
                //                 </span>
                //             </Tooltip>
                //             {(roles?.includes('admin') || roles?.includes('fms_hr')) &&
                //             <Tooltip title={'Delete'}>
                //                 <span>
                //                 <MdDeleteOutline size={14} onClick={() => {setdata({...data,id:d._id,client_name:d.client_name,client_no:d.client_no,site_name:d.site_name,site_address:d.site_address,are_we_serving:d.are_we_serving});setmodalvisible(true)}} style={{ color: '#000' }} />
                //                 </span>
                //             </Tooltip>}
                //             </p>}
                //         </div>
                //     ))}

                // <div style={{marginTop:'40px',display:'flex',justifyContent:'center'}}> 
                // {pagination?.total > pagination?.limit &&
                //     <Pagination current={page} size="small" total={pagination?.total} onChange={(v) => setpagefuun(v)}  pageSize={pagination?.limit} />
                // }
                // </div>


                // </div> 
                :
                <div style={{ display: 'grid', justifyContent: 'center', alignItems: 'center', marginTop: '100px' }}>
                    <img src={data_not_found} alt="nodatafouund" style={{ margin: 'auto', width: '180px', objectFit: 'contain' }} />
                    <h4 style={{ fontSize: '15px', fontWeight: '700', marginTop: '10px', textAlign: 'center',marginBottom:'0px' }}>{"You don't have any designation created yet"}</h4>
                    <h4 style={{ fontSize: '12px', fontWeight: '500', marginTop: '2px', textAlign: 'center',opacity:'0.8' }}>{"To add employee designation click on the add button and create a new designation and submit"}</h4>
                </div>}
                </div>
              
         </FmsDashboardMainRoot>
    )
}




export default FmsDesignationOnboardEmployee